import React from 'react';
export function SectionImage() {
  return <section className="w-full" data-id="element-114">
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772487801/hf_20260302_213840_39d21cb6-8b5a-46d8-9339-2bc47ff6d1e0_s4fxne.jpg" alt="Sección promocional" className="w-full block" style={{
      display: 'block'
    }} data-id="element-115" />
    </section>;
}